window.initImageSlider ?? (() => {
  window.initImageSlider = (section_id) => {
    console.log(section_id);
    var swiper = new Swiper(`#shopify-section-${section_id} .swiper`, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
        },
        on: {
        slideChange: function () {
          const currentSlideIndex = this.realIndex;
          console.log(currentSlideIndex)
        }
      }
  });
}
})();